import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { primeFeedData } from './utils/feedPrefetch';
import { Home, Log_in, Registrations, Profile, EditProfile, Search,
  NewQuestionnaire, Chats, Profile2, AutoLogin } from './pages';
import Feed from './pages/Feed/Feed';
import Sympathies from './pages/Sympathies/Sympathies';
import Header from './components/Header';
import UserProfile from './pages/UserProfile/UserProfile';
import UiPreview from './pages/UiPreview/UiPreview';
import { initializeTheme } from './utils/theme';

function AppLayout() {
  const location = useLocation();
  const { pathname } = location;

  const renderHeader = () => {
    if (pathname === '/') return <Header />;
    if (pathname === '/log_in') return <Header activeHref="/log_in" authenticated={false} />;
    if (pathname === '/registrations') return <Header activeHref="/log_in" authenticated={false} />;
    if (pathname.startsWith('/auto-login/')) return <Header activeHref="/log_in" authenticated={false} />;
    if (pathname === '/feed') return <Header activeHref="/feed" authenticated />;
    if (pathname === '/profile' || pathname === '/edit-profile' || pathname === '/profile2') {
      return <Header activeHref="/profile" authenticated />;
    }
    if (pathname === '/search') return <Header activeHref="/search" authenticated />;
    if (pathname === '/new-questionnaire') return <Header activeHref="/questionnaire" authenticated />;
    if (pathname === '/chats') return <Header activeHref="/chats" authenticated />;
    if (pathname === '/sympathies') return <Header activeHref="/sympathies" authenticated />;
    if (pathname.startsWith('/user/')) return <Header activeHref={null} authenticated />;
    return null;
  };

  return (
    <>
      {renderHeader()}
      <Outlet />
    </>
  );
}

function ProfileBackLayout() {
  const navigate = useNavigate();

  return (
    <>
      <div className="search-page">
        <main className="search-page__main mx-auto">
          <div className="search-page__back md:mt-0">
            <button onClick={() => navigate(-1)} className="search-page__back-button" type="button">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="rotate-0" aria-hidden="true">
                <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Назад
            </button>
          </div>
        </main>
      </div>
      <Outlet />
    </>
  );
}

function App() {
  useEffect(() => {
    initializeTheme();

    if (localStorage.getItem('token')) {
      primeFeedData();
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/feed" element={<Feed />} />
            <Route path="/log_in" element={<Log_in />} />
            <Route path="/auto-login/:linkId" element={<AutoLogin />} />
            <Route path="/registrations" element={<Registrations />} />
            <Route path="/search" element={<Search />} />
            <Route path="/new-questionnaire" element={<NewQuestionnaire />} />
            <Route path="/chats" element={<Chats />} />
            <Route path="/profile2" element={<Profile2 />} />
            <Route path="/sympathies" element={<Sympathies />} />
            <Route element={<ProfileBackLayout />}>
              <Route path="/profile" element={<Profile />} />
              <Route path="/edit-profile" element={<EditProfile />} />
              <Route path="/user/:userId" element={<UserProfile />} />
            </Route>
          </Route>
          <Route path="/Header_Reg" element={<Header authenticated={false} />} />
          <Route path="/Header_Que" element={<Header activeHref="/questionnaire" authenticated />} />
          <Route path="/Header_Prof" element={<Header activeHref="/profile" authenticated />} />
          <Route path="/Header_Search" element={<Header activeHref="/search" authenticated />} />
          <Route path="/Header_Feed" element={<Header activeHref="/feed" authenticated />} />
          <Route path="/Header_Chats" element={<Header activeHref="/chats" authenticated />} />
          <Route path="/Header_Sympathies" element={<Header activeHref="/sympathies" authenticated />} />
          <Route path="/ui-preview" element={<UiPreview />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
